var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[_vm.$style.baseBanner, _vm.$style[("isStyle" + _vm.type)], ( _obj = {}, _obj[_vm.$style.isStyleDingBeauty] = _vm.$globalIsDingBeauty, _obj )],style:({ backgroundImage: ("url('" + _vm.image + "')") })},[_c('h1',{staticClass:"baseBanner__title",class:_vm.titleClass},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }